module.exports = __webpack_public_path__ + "static/media/020.1d7fe46e.jpg";